import React from "react";
import { Container, Typography, Box, Button, Paper } from "@mui/material";
import ImageDisplay from "./ImageDisplay";

const Certificate = ({ gotocoaching }) => {
	  return (
		      <Container maxWidth="md" sx={{ mt: 6 }}>
			  <Button color="inherit" onClick={gotocoaching} sx={{ mr: 1 }}>
				Coaching Home
			  </Button>
			  <br/>
		        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: "center" }}>
		          <Typography variant="h4" component="h1" gutterBottom>
		            Certificates from State of Missouri
		          </Typography>

		          <Box
		            sx={{
				                mt: 4,
					                display: "flex",
					                justifyContent: "center",
					                alignItems: "center",
					                maxHeight: 500,
					                overflow: "hidden",
					              }}
		          >
		            <ImageDisplay imageName="cert.png" alt="Certificate" />
		          </Box>
		        </Paper>
		      </Container>
		    );
};

export default Certificate;

